export const EXTRA_LARGE_DEVICE_WIDTH: number = 1200;

export const LARGE_DEVICE_WIDTH: number = 1024;

export const MEDIUM_DEVICE_WIDTH: number = 768;

export const SMALL_DEVICE_WIDTH: number = 480;

export const EXTRA_SMALL_DEVICE_WIDTH: number = 320;
